import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	removeTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	removeTooltip: {
		id: 'issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip',
		defaultMessage: 'Remove',
		description: 'Tooltip message shown for the button to remove a link.',
	},
});
export default messages;
